<script lang="ts">
    import { onMount } from "svelte";
    import { APIHelper } from "../code/APIHelper";
    import DBG from "../code/DBG";
    import Loader from "./Loader.svelte";

    let state = 0;

    onMount(() => {
        DBG.log("StartAuth - onMount");

        Office.onReady((info) => {
            DBG.log("StartAuth - Office onReady called", info);
            if (info.host !== Office.HostType.Project) {
                DBG.log(
                    "StartAuth - Office onReady error - not hosted in Project"
                );
            }
            APIHelper.getAuthInfo()
                .then((val) => {
                    DBG.log("StartAuth - onMount - getAuthInfo returned", val);
                    if (val.clientPrincipal) {
                        state = 1;
                        setTimeout(() => {
                            msgParent();
                        }, 1000);
                    } else {
                        state = 2;
                    }
                })
                .catch((reason) => {
                    DBG.log("StartAuth - onMount - getAuthInfo catch", reason);
                    state = 2;
                });
        });
    });

    function closeButtonClick() {
        var messageObject = { messageType: "dialogClosed" };
        var jsonMessage = JSON.stringify(messageObject);
        Office.context.ui.messageParent(jsonMessage);
        console.log("closeButtonClick");
    }
    function msgParent() {
        console.log("Messaging parent");
        Office.context.ui.messageParent("Auth done");
        closeButtonClick();
    }
    function checkAuth() {
        APIHelper.getUserFromAPI()
            .then((auth) => {
                document.getElementById("auth-info").innerText =
                    JSON.stringify(auth);
            })
            .catch((reason) => {
                document.getElementById("auth-info").innerText =
                    JSON.stringify(reason);
            });
    }
</script>

<div>
    {#if state == 0}
        <Loader text="Checking authentication" />
    {:else if state == 1}
        <p>You are now logged in.</p>
    {:else}
        <div class="row" id="unauth-main">
            <div class="col-md-6">
                <img
                    src="img/logo.png"
                    alt="Time-location add-in for Microsoft Project"
                />
                <p>
                    To use the Time-location Microsoft Project add-in, you must
                    log in with your
                    <strong>@tlmsp.com</strong> username and password.
                </p>
                <div id="login-btn">
                    <i class="fa fa-sign-in-alt" />
                    <a
                        href="/.auth/login/aad?post_login_redirect_uri={window
                            .location.origin}/startauth">LOG IN</a
                    >
                </div>

                <hr />
                <p>Having trouble logging in?</p>
                <p>
                    <i class="fa fa-envelope" />
                    <a
                        href="mailto:costin@4projects.ro, office@4projects.ro?subject=TLMSP support request"
                        >Contact support</a
                    >
                </p>
                <hr />
                <p class="mt-3">Interested in buying the TLMSP addin?</p>
                <p>
                    <i class="fa fa-file-contract" />
                    <a href="https://tlmsp.com" target="_blank">Use this form</a
                    >
                </p>

                <button
                    type="button"
                    class="btn btn-primary"
                    on:click={msgParent}>Close</button
                >

                <button
                    type="button"
                    class="btn btn-primary"
                    on:click={checkAuth}>Check auth</button
                >
                <div id="auth-info" />
            </div>
        </div>
    {/if}
</div>

<style>
    #unauth-main {
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: tlmsp;
        padding: 1rem;
    }

    #unauth-main img {
        width: 100%;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }

    @font-face {
        font-family: tlmsp;
        src: url(font/Microsoft\ Sans\ Serif.ttf);
    }
    #login-btn {
        font-size: 3rem;
        font-weight: bold;
    }
</style>
